module.exports = __webpack_public_path__ + "static/img/noList85dc76e.png";